import { RefObject, useMemo } from "react";
import { BuilderPhoneDimensions, getViewModePhoneDimensions } from "../utils";
import useViewModeQueryParams from "./useViewModeQueryParams";
import useGetRefPositionAndDimensions from "./useGetRefPositionAndDimensions";

type Params = { ref: RefObject<HTMLDivElement> };
type Return = BuilderPhoneDimensions;

const useGetBuilderPhoneDimensions = (params: Params): Return => {
  const { viewMode } = useViewModeQueryParams();
  const smallAndMediumPhoneDimensions = getViewModePhoneDimensions(
    viewMode || "medium-screens",
  );
  const dynamicPhoneDimensions = useGetRefPositionAndDimensions({
    ref: params.ref,
    sizeOffset: PIXELS_TO_SUBTRACT_FROM_FULL_HEIGHT,
  });
  const phoneDimensions = useMemo(() => {
    return smallAndMediumPhoneDimensions || dynamicPhoneDimensions;
  }, [dynamicPhoneDimensions, smallAndMediumPhoneDimensions]);
  return useMemo(() => {
    return phoneDimensions;
  }, [phoneDimensions]);
};

export const PIXELS_TO_SUBTRACT_FROM_FULL_HEIGHT = 132;

export default useGetBuilderPhoneDimensions;
